import { CommonModuleInner } from '@/sem/styles';
import type { SemActionBannerModule } from '~/contracts/sem';
import {
  SectionTitle,
  SectionSubtitle,
  GridContent,
  ActionBanner,
  BannerTitle,
  BannerSubtitle,
  BannerImg,
  ImgWrapper
} from './ActionBanners.styles';
import SemTrackWrapper from '../SemTrackWrapper';

type OwnProps = Omit<SemActionBannerModule, '__typename'>;

function ActionBanners({ id, subtitle, title, items }: OwnProps) {
  return id && items ? (
    <SemTrackWrapper sectionName="Action Banners">
      <CommonModuleInner>
        {title && <SectionTitle>{title}</SectionTitle>}
        {subtitle && <SectionSubtitle>{subtitle}</SectionSubtitle>}
        <GridContent>
          {items.map(item => {
            return item?.slug ? (
              <a
                href={item.slug}
                key={item.title}
                className="inline-block !w-full no-underline"
                data-analytics-id="Action Banners - Link"
                data-analytics-attributes={JSON.stringify({
                  title: item.title,
                  linkUrl: item.slug
                })}
              >
                <ActionBanner>
                  {item.imageSrc && (
                    <ImgWrapper>
                      <BannerImg
                        src={item.imageSrc}
                        alt={item?.title ?? 'Promo Img'}
                      />
                    </ImgWrapper>
                  )}
                  <div className="w-full pt-24">
                    {item?.title && <BannerTitle>{item?.title}</BannerTitle>}
                    {item?.subtitle && (
                      <BannerSubtitle>{item?.subtitle}</BannerSubtitle>
                    )}
                  </div>
                </ActionBanner>
              </a>
            ) : null;
          })}
        </GridContent>
      </CommonModuleInner>
    </SemTrackWrapper>
  ) : null;
}

export default ActionBanners;
